<div class="category-section">
  <div class="title">{{ category }}</div>
  <div class="content" [ngSwitch]="category">
    <div *ngSwitchCase="'Clinical Chemistry'">
      The highest workload in the laboratory, Clinical Chemistry is automated
      and full of numbers.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      covers a wide range of both basic and specialised topics.
    </div>
    <div *ngSwitchCase="'Clinical Pathology'">
      Often relegated to a corner and the junior technical staff, Clinical
      Pathology is an eye opener and a Pandora’s box.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      covers several aspects of testing and interpretation that is usually taken
      for granted.
    </div>
    <div *ngSwitchCase="'Hematology'">
      The study of blood cells and cell counters throws up immense possibilities
      for diagnosis of various disorders.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      has a range of courses that delve into this interesting speciality
    </div>
    <div *ngSwitchCase="'Immunoassay'">
      Antigen antibody reactions, from the basics to the details all explained
      in the various courses laid out by
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>. Making it simple
    </div>
    <div *ngSwitchCase="'Quality Assurance'">
      Quality is the mantra that is part of the fabric of every good laboratory.
      Quality systems, Quality management, Quality assurance, its all there at
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
    </div>
    <div *ngSwitchCase="'Samples & Pre-Analytics'">
      Still the most important part of the laboratory, often neglected leading
      to majority of errors. The right sample means the right result,
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      has designed courses to get it right, the first time and every time.
    </div>
    <div *ngSwitchCase="'Micro-Biology'">
      The world of microbes, detection, resistance and automation, there is a
      lot that is happening in this speciality.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      has a gamut of courses that cater to the novice also.
    </div>
    <div *ngSwitchCase="'General'">
      The most happening diagnostic platform.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      explains the basics, equipment, detection and interpretation in well laid
      out courses.
    </div>
    <div *ngSwitchCase="'Transfusion Medicine'">
      This speciality is more than just donations and transfusions.
      <span class="logo-name">
        The <span class="lab">Lab</span>oratory Matters</span>
      explains it all, basics to the most recent.
    </div>
  </div>
  <div class="scrollable-courses" *ngIf="courseList?.length">
    <div class="left-arrow" *ngIf="courseList?.length > 3" (click)="scrollLeft()">
      <i class="fa-solid fa-angle-left"></i>
    </div>
    <div #courses class="courses">
      <div class="course" *ngFor="let course of courseList" (click)="onClickCourse(course._id)">
        <div class="thumbnail">
          <img [src]="'data:image/jpeg;base64,' + course.thumbnail.buffer" alt="" loading="lazy" decoding="async" />
        </div>
        <div class="title-section">
          <div class="left">
            <div class="name">{{ course.title }}</div>
            <div class="duration">{{ course.duration || "duration" }}</div>
          </div>
          <div class="description">
            {{ course.description }}
          </div>
        </div>
        <div class="no-message" *ngIf="courseList?.length == 0">
          No Courses Found!
        </div>
      </div>
    </div>
    <div class="right-arrow" *ngIf="courseList?.length > 3" (click)="scrollRight()">
      <i class="fa-solid fa-angle-right"></i>
    </div>
  </div>
  <div class="no-courses" *ngIf="!courseList?.length">Keep watching this space for course announcements!</div>
</div>